import { Controller } from "@hotwired/stimulus"

// View-only lightbox for the public profile pages. Opens any element clicked
// that has data-public-lightbox-src and data-action="click->public-lightbox#open".
// Close with the X button, the backdrop, or Escape.
export default class extends Controller {
  static targets = ["modal", "image", "caption"]

  open(event) {
    event.preventDefault()
    const trigger = event.currentTarget
    const src = trigger.dataset.publicLightboxSrc
    const caption = trigger.dataset.publicLightboxCaption || ""
    if (!src) return

    this.imageTarget.src = src
    if (this.hasCaptionTarget) {
      this.captionTarget.textContent = caption
      this.captionTarget.classList.toggle("hidden", caption.length === 0)
    }
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close(event) {
    // Close on X button or clicking the backdrop itself (not children)
    if (event.target === this.modalTarget || event.currentTarget.dataset.publicLightboxClose !== undefined) {
      this.doClose()
    }
  }

  closeButton() {
    this.doClose()
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.doClose()
    }
  }

  doClose() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
    // Clear src so closing also stops a slow-loading image from continuing
    this.imageTarget.src = ""
  }
}
